<template>
  <div class="auth">
    <b-overlay :show="loading" rounded="sm" no-wrap fixed>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="stopwatch" font-scale="2" animation="cylon"></b-icon>
          <p id="cancel-label" class="small">
            Авторизация...
          </p>
        </div>
      </template>
    </b-overlay>

    <form
      class="d-flex justify-content-center"
      @submit.prevent="authentication"
    >
      <div style="width: 320px">
        <p class="text-center">
          <img
            alt="ТЭК-Торг Электронный документооборот"
            src="@/assets/logo.png"
          />
        </p>

        <b-form-input
          v-model="username"
          class="mt-2"
          placeholder="Логин"
          :maxlength="LOGIN_LENGTH"
        />
        <b-form-input
          v-model="password"
          type="password"
          class="mt-2"
          placeholder="Пароль"
          :maxlength="PASSWORD_LENGTH"
        />

        <b-button-group class="d-flex mt-2">
          <b-button
            variant="edo"
            size="sm"
            :disabled="!username || !password"
            type="submit"
            >Войти</b-button
          >
          <b-button
            variant="edo"
            size="sm"
            @click="$router.push('/registration')"
            >Регистрация</b-button
          >
          <b-button
            variant="edo"
            size="sm"
            @click="$router.push('/forgot-password')"
            >Восстановить доступ</b-button
          >
        </b-button-group>

        <div
          :class="
            `${
              errorText === invalidCredentialsText
                ? 'd-flex justify-content-center'
                : ''
            }`
          "
        >
          <Error
            :error-details="moreErrorInfo"
            :error-text="errorText"
            :large-text="false"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { securityActor, subscriberActor } from '@/urls'
import Error from '@/components/error'

const invalidCredentialsText = 'Неверный логин или пароль'

export default {
  name: 'Login',
  components: {
    Error
  },
  data: () => ({
    invalidCredentialsText,
    username: '',
    password: '',
    errorText: '',
    moreErrorInfo: '',
    loading: true,
    LOGIN_LENGTH: 99,
    PASSWORD_LENGTH: 99
  }),
  created() {
    this.clearLocalStorage()
    this.loading = false
  },
  methods: {
    setError(error, text) {
      this.loading = false
      this.moreErrorInfo = text === invalidCredentialsText ? '' : error.response
      this.errorText = text
      throw error
    },
    async authentication() {
      this.loading = true
      const { access_token } = await this.login()
      const { subscriberGid } = await this.getGid(access_token)
      if (subscriberGid) {
        const orgInfo = await this.getTekTorgOrgInfo(
          subscriberGid,
          access_token
        )
        const { details, gid } = orgInfo
        const { name, inn, kpp } = details
        if (name.first) {
          localStorage.setItem(
            'orgName',
            `${name.first} ${name.middle} ${name.last}`
          )
        } else {
          localStorage.setItem('orgName', name)
          localStorage.setItem('inn', inn)
          if (kpp) localStorage.setItem('kpp', kpp)
        }
        localStorage.setItem('gid', gid)
        localStorage.setItem('token', access_token)

        this.loading = false
        this.$router.push('/incoming')
      }
    },
    async getTekTorgOrgInfo(gid, token) {
      const url = `${subscriberActor}/subscribers?gid=${gid}`
      const headers = { Authorization: `Bearer  ${token}` }
      try {
        const { data } = await axios.get(url, { headers })
        return data[0]
      } catch (error) {
        this.setError(error, 'Ошибка получения данных об организации')
      }
    },
    async getGid(token) {
      const url = `${subscriberActor}/memberships?user-id=me`
      const headers = { Authorization: `Bearer  ${token}` }
      try {
        const { data } = await axios.get(url, { headers })
        if (!data.length) {
          this.loading = false
          this.errorText =
            ' Пользователь не привязан к организации, обратитесь в службу технической поддержки'
          return { subscriberGid: false }
        }
        return data[0]
      } catch (error) {
        this.setError(error, 'Ошибка получения GID')
      }
    },
    async login() {
      const url = `${securityActor}/user-login`
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        accept: 'application/json'
      }
      const params = new URLSearchParams()
      params.append('username', this.username)
      params.append('password', this.password)

      try {
        const { data } = await axios.post(url, params, {
          headers
        })
        return data
      } catch (error) {
        const errorText =
          error.response.status === 400
            ? invalidCredentialsText
            : 'Ошибка отправки логина/пароля'
        this.setError(error, errorText)
      }
    },
    clearLocalStorage() {
      localStorage.removeItem('inn')
      localStorage.removeItem('kpp')
      localStorage.removeItem('orgName')
      localStorage.removeItem('gid')
      localStorage.removeItem('token')
    }
  }
}
</script>
